import { service } from '@ember/service'
import { t } from 'ember-intl'
import type SideNavService from 'teacher-ui-client/services/side-nav'
import Component from '@glimmer/component'

interface Signature {
  Element: HTMLDivElement
}

export class SideNavMathsHelpJuice extends Component<Signature> {
  @service sideNav!: SideNavService

  get isVisible() {
    return this.sideNav.showHelpJuiceBanner
  }

  <template>
    {{#if this.isVisible}}
      <div
        class="border-forest-green-300 bg-forest-green-50 text-forest-green-300 rounded-sm border px-2 py-3 text-center"
        ...attributes
      >
        <p class="mb-3">
          {{t "sideNav.maths.alert.heading"}}
        </p>
        <p>
          {{t "sideNav.maths.alert.linkPrefix"}}
          <a
            class="text-ms-green-350 hover:text-ms-green-325 focus:text-ms-green-325 font-semibold"
            href="https://help.mathseeds.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{t "sideNav.maths.alert.link"}}
          </a>
          {{t "sideNav.maths.alert.linkSuffix"}}
        </p>
      </div>
    {{/if}}
  </template>
}

export default SideNavMathsHelpJuice
